import { HomeOutlined } from '@ant-design/icons';
import { Fragment } from 'react';

import { HorizontallySpaced } from '../../../styles/layout';
import { LoadingSkeleton } from '../../loading-skeleton';
import { Separator, StyledLink } from './styles';

export type BreadCrumb = {
  url: string;
  title?: string;
  loading?: boolean;
};

export function BreadCrumbs({ links }: { links: BreadCrumb[] }) {
  return (
    <HorizontallySpaced $factor={0.5}>
      <StyledLink icon to="/" aria-label="Home">
        <HomeOutlined />
      </StyledLink>
      {links.map((link, index) => (
        <Fragment key={index}>
          <Separator />
          {link.loading ? (
            <LoadingSkeleton inline width={100} />
          ) : (
            <StyledLink selected={links.length - 1 === index} to={link.url}>
              {link.title}
            </StyledLink>
          )}
        </Fragment>
      ))}
    </HorizontallySpaced>
  );
}
